import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchCoupon: DocumentNode = gql`
  query FetchCoupon($couponCode: String) {
    coupon: fetchCoupon(id: $couponCode) {
      ... on SubscriptionCoupon {
        id
        name
        code
        state
        duration
        temporalUnit
        temporalAmount
        appliesToAllPlans
        maxRedemptionsPerAccount
        uniqueCouponCode {
          code
          state
        }
        discount {
          percent
          type
          currencies {
            amount
            currency
          }
          trial {
            length
            unit
          }
        }
        plans {
          code
        }
      }
      ... on SubscriptionCouponNotFound {
        error {
          message
        }
      }
    }
  }
`

export default fetchCoupon
